module.exports = __webpack_public_path__ + "img/顶部UPAY-logo@2x.070d63ee.png";